import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'

import { RouteAuthorizer } from '../Authorizer'
import BookingsRoutes from './Bookings'
import ManagementRoutes from './Management'
import MarketingRoutes from './Marketing'
import ConfigurationsRoutes from './Configurations'
import ConfigurationsTemplates from 'views/Dashboard/Marketing/Templates'
import Overview from 'views/Dashboard/Overview'
import Conversations from 'components/Conversations'
import UserProfile from '../../views/Dashboard/UserProfile'
import withNotifications from '../../hocs/withNotifications'
import ConsoleRoutes from './ConsoleFAQ'
import SearchResultsRoutes from './SearchResults'
import IntranetRoutes from './Intranet'
import MetricsRoutes from './Metrics'
import IntegrationsRoute from './Integrations'

const AuthorizedOverview = RouteAuthorizer(['user', 'comunityManager'])(Overview)
const AuthorizedUserProfile = RouteAuthorizer(['user'])(UserProfile)
const AuthorizedConversations = RouteAuthorizer(['user', 'comunityManager'])(Conversations)
const AuthorizedMarketing = RouteAuthorizer(['user'])(MarketingRoutes)
const AuthorizedBookings = RouteAuthorizer(['user', 'comunityManager'])(BookingsRoutes)
const AuthorizedManagement = RouteAuthorizer(['user'])(ManagementRoutes)
const AuthorizedConfigurations = RouteAuthorizer(['user'])(ConfigurationsRoutes)
const AuthorizedTemplates = RouteAuthorizer(['user'])(ConfigurationsTemplates)
const AuthorizedConsole = RouteAuthorizer(['user'])(ConsoleRoutes)
const AuthorizedSearchResults = RouteAuthorizer(['user'])(SearchResultsRoutes)
const AuthorizedIntranet = RouteAuthorizer([])(IntranetRoutes)
const AuthorizedMetrics = RouteAuthorizer([])(MetricsRoutes)
const AuthorizedIntegrations = RouteAuthorizer([])(IntegrationsRoute)

const Index = ({ match }) => (
  <Switch>
    <Route path={`${match.path}/conversations/templates`} component={AuthorizedTemplates} />
    <Route path={`${match.path}/conversations/:sidemenu/:user?`} component={AuthorizedConversations} />
    <Route path={`${match.path}/marketing`} component={AuthorizedMarketing} />
    <Route path={`${match.path}/bookings`} component={AuthorizedBookings} />
    <Route path={`${match.path}/management`} component={AuthorizedManagement} />
    <Route path={`${match.path}/configurations`} component={AuthorizedConfigurations} />
    <Route path={`${match.path}/profile`} component={AuthorizedUserProfile} />
    <Route path={`${match.path}/overview`} component={AuthorizedOverview} />
    <Route path={`${match.path}/automation`} component={AuthorizedConsole} />
    <Route path={`${match.path}/searchresults`} component={AuthorizedSearchResults} />
    <Route path={`${match.path}/metrics`} component={AuthorizedMetrics} />
    <Route path={`${match.path}/integrations`} component={AuthorizedIntegrations} />
    <Route path={`${match.path}/intranet`} component={AuthorizedIntranet} />
    <Redirect to={`${match.path}/`} />
  </Switch>
)

export default withNotifications(Index)
